// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckMail_container__18vGu"};